var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useCallback, useEffect } from "react";
import { Button, Loading, AccordionSet, Accordion, } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { uploadTitleFile, startTitleImportFromFile, fetchActiveTitleImport, } from "../../api/titleImportService";
import { useTitleImportProgress } from "../../hooks/useTitleImportProgress";
import { useStableOkapiKy } from "../../hooks/useStableOkapiKy";
import { TitleImportProgress } from "./TitleImportProgress";
import { OwnCloudTitleImportSection } from "./OwnCloudTitleImportSection";
import styles from "./titleImport.module.css";
var TITLE_IMPORT_FILE_KEY = "title-import-file";
export var TitleImportForm = function () {
    // Stable instance: `recoverActiveImport` feeds the mount effect below, so an
    // unstable ky would re-fetch the active import on every render (every poll).
    var kyInstance = useStableOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _a = useState(null), file = _a[0], setFile = _a[1];
    var _b = useState(null), fileName = _b[0], setFileName = _b[1];
    var _c = useState(false), isUploading = _c[0], setIsUploading = _c[1];
    var _d = useState(null), error = _d[0], setError = _d[1];
    var _e = useState({
        owncloud: true,
        manual: false,
    }), accordionStatus = _e[0], setAccordionStatus = _e[1];
    var recoverActiveImport = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var active, cached;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchActiveTitleImport(kyInstance)];
                case 1:
                    active = _a.sent();
                    if (active === null || active === void 0 ? void 0 : active.fileName) {
                        setFileName(active.fileName);
                        sessionStorage.setItem(TITLE_IMPORT_FILE_KEY, active.fileName);
                    }
                    else {
                        cached = sessionStorage.getItem(TITLE_IMPORT_FILE_KEY);
                        if (cached) {
                            setFileName(cached);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [kyInstance]);
    useEffect(function () {
        recoverActiveImport();
    }, [recoverActiveImport]);
    var progress = useTitleImportProgress(fileName);
    var isImportRunning = !!fileName && (progress === null || progress === void 0 ? void 0 : progress.status) === "IN_PROGRESS";
    var handleFileChange = function (e) {
        var selectedFile = e.target.files ? e.target.files[0] : null;
        setFile(selectedFile);
    };
    var handleUploadAndImport = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!file)
                        return [2 /*return*/];
                    setIsUploading(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, uploadTitleFile(kyInstance, file)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, startTitleImportFromFile(kyInstance, file.name)];
                case 3:
                    _a.sent();
                    setFileName(file.name);
                    sessionStorage.setItem(TITLE_IMPORT_FILE_KEY, file.name);
                    return [3 /*break*/, 6];
                case 4:
                    err_1 = _a.sent();
                    console.error("Title import error:", err_1);
                    setError(err_1 instanceof Error
                        ? err_1.message
                        : formatMessage({
                            id: "ui-br-agency.import.titleImport.error.unknown",
                        }));
                    return [3 /*break*/, 6];
                case 5:
                    setIsUploading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); }, [file, kyInstance, formatMessage]);
    var handleOwnCloudImportStarted = useCallback(function () {
        recoverActiveImport();
    }, [recoverActiveImport]);
    var toggleAccordion = function (id) {
        setAccordionStatus(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[id] = !prev[id], _a)));
        });
    };
    return (React.createElement("div", null,
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { id: "owncloud-title-import", label: formatMessage({
                    id: "ui-br-agency.import.titleImport.owncloud.accordion.title",
                }), open: accordionStatus.owncloud, onToggle: function () { return toggleAccordion("owncloud"); } },
                React.createElement(OwnCloudTitleImportSection, { onImportStarted: handleOwnCloudImportStarted })),
            React.createElement(Accordion, { id: "manual-title-import", label: formatMessage({
                    id: "ui-br-agency.import.titleImport.manual.accordion.title",
                }), open: accordionStatus.manual, onToggle: function () { return toggleAccordion("manual"); } },
                React.createElement("div", { className: styles.formContainer },
                    React.createElement("input", { type: "file", onChange: handleFileChange, accept: ".xml" }),
                    React.createElement(Button, { buttonStyle: "primary", onClick: handleUploadAndImport, disabled: !file || isUploading || isImportRunning }, formatMessage({
                        id: "ui-br-agency.import.titleImport.button.upload",
                    })),
                    isUploading && React.createElement(Loading, null)),
                error && React.createElement("div", { className: styles.errorMessage }, error))),
        progress && React.createElement(TitleImportProgress, { progress: progress })));
};
